import { Input } from 'antd';

import SearchOutlined from '../../../assets/common/SearchOutlined';
import styles from './AppSearchInput.module.scss';

const AppSearchInput = ({ className = '', ...props }) => {
  return (
    <Input
      className={`${styles.appSearchInput} ${className}`}
      prefix={<SearchOutlined />}
      allowClear
      {...props}
    />
  );
};

export default AppSearchInput;
